import {
    IFRAME_SET_VISIBILITY,
    IFRAME_SET_DIMENSIONS,
    IFRAME_SET_LOADED,
    IFRAME_SET_RENDERED,
    IFRAME_SET_CLASSNAME,
    IFRAME_SET_SLOT_CLOSE_REQUEST,
} from './redux-constants';
import { IFrameApp, IframeApps } from '../components/persistent-iframe/persistent-iframe.constants';

const getDefaultDimensions = () => ({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
});

const objectHasOwnProperty = (obj: any, key: string): boolean => ({}).hasOwnProperty.call(obj, key);

const getDefaultAppEntry = () => ({
    visibility: false,
    dimensions: getDefaultDimensions(),
    isLoaded: false,
    isRendered: false,
    className: '',
    closeRequestedSlot: null,
});

const getDefaultState = () => {
    const defaultState: Record<string, any> = {};
    Object.keys(IframeApps).forEach((value: string) => {
        if (objectHasOwnProperty(IframeApps, value)) {
            defaultState[IframeApps[value as IFrameApp]] = getDefaultAppEntry();
        }
    });
    return defaultState;
};

const getAppEntry = (state: any, appName: string) => state[appName] || getDefaultAppEntry();

const persistentIframeReducer = (state: any = getDefaultState(), action: any) => {
    const { visibility, appName } = action;
    switch (action.type) {
        case IFRAME_SET_VISIBILITY: {
            const existing = getAppEntry(state, appName);
            const dimensionToSet = visibility ? existing.dimensions : getDefaultDimensions();
            return {
                ...state,
                [appName]: {
                    ...existing,
                    visibility,
                    dimensions: dimensionToSet,
                },
            };
        }

        case IFRAME_SET_DIMENSIONS: {
            return {
                ...state,
                [action.appName]: {
                    ...getAppEntry(state, action.appName),
                    dimensions: action.dimensions,
                },
            };
        }

        case IFRAME_SET_LOADED: {
            return {
                ...state,
                [action.appName]: {
                    ...getAppEntry(state, action.appName),
                    isLoaded: action.isLoaded,
                },
            };
        }

        case IFRAME_SET_RENDERED: {
            return {
                ...state,
                [action.appName]: {
                    ...getAppEntry(state, action.appName),
                    isRendered: action.isRendered,
                },
            };
        }

        case IFRAME_SET_CLASSNAME: {
            return {
                ...state,
                [action.appName]: {
                    ...getAppEntry(state, action.appName),
                    className: action.className,
                },
            };
        }

        case IFRAME_SET_SLOT_CLOSE_REQUEST: {
            return {
                ...state,
                [action.appName]: {
                    ...getAppEntry(state, action.appName),
                    closeRequestedSlot: action.slot,
                },
            };
        }

        default: return state;
    }
};

export default persistentIframeReducer;
